import { render, staticRenderFns } from "./NewCategoryListing.vue?vue&type=template&id=78f97436&scoped=true"
import script from "./NewCategoryListing.vue?vue&type=script&lang=js"
export * from "./NewCategoryListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f97436",
  null
  
)

export default component.exports